// Icons sourced from Icons8.com
const armchair = '/images/icons/Armchair-100.png';
const barcode = '/images/icons/barcode_150x150.png';
const box = '/images/icons/Box-100.png';
const cashregister = '/images/icons/Cash Register-100.png';
const cable = '/images/icons/Cable-100.png';
const cd = '/images/icons/CD-100.png';
const chair = '/images/icons/Chair-100.png';
const citybench = '/images/icons/City Bench-100.png';
const clock = '/images/icons/Clock-100.png';
const computer = '/images/icons/Computer-100.png';
const desk = '/images/icons/Desk-100.png';
const desklamp = '/images/icons/Desk Lamp-100.png';
const dockingStation = '/images/icons/Docking-Station-100.png';
const dvd = '/images/icons/DVD Logo-100.png';
const fan = '/images/icons/Fan-100.png';
const fileCabinet = '/images/icons/FileCabinet-100.png';
const headphones = '/images/icons/Headphones-100.png';
const headset = '/images/icons/Headset-100.png';
const hub = '/images/icons/Hub-100.png';
const imac = '/images/icons/iMac-100.png';
const ipad = '/images/icons/iPad-100.png';
const iphone = '/images/icons/iPhone-100.png';
const keyboard = '/images/icons/Keyboard-100.png';
const laptop = '/images/icons/Laptop-100.png';
const microphone = '/images/icons/Microphone 2-100.png';
const monitor = '/images/icons/Monitor-100.png';
const motherboard = '/images/icons/Motherboard-100.png';
const mouse = '/images/icons/Mouse-100.png';
const nas = '/images/icons/NAS-100.png';
const networkcard = '/images/icons/Network Card-100.png';
const other = '/images/icons/Other-100.png';
const pedestal = '/images/icons/Pedestal-100.png';
const print = '/images/icons/Print-100.png';
const processor = '/images/icons/Processor-100.png';
const router = '/images/icons/Router-100.png';
const scanner = '/images/icons/Scanner-100.png';
const server = '/images/icons/Server-100.png';
const sofa = '/images/icons/Sofa-100.png';
const speaker = '/images/icons/Speaker-100.png';
const networkSwitch = '/images/icons/Switch-100.png';
const trophy = '/images/icons/Trophy-100.png';
const tv = '/images/icons/TV-100.png';
const webcam = '/images/icons/Webcam-100.png';
const wheelchair = '/images/icons/Wheelchair-100.png';
const workstation = '/images/icons/Workstation-100.png';

const inventorize = '/images/icons/barcode_150x150.png';
const disconnect = '/images/icons/discconnected_150x150.png';
const pickup = '/images/icons/arrow_up_150x150.png';
const dropoff = '/images/icons/arrow_down_150x150.png';
const reconnect = '/images/icons/connected_150x150.png';
const complete = '/images/icons/checkmark_150x150.png';

export default {
  armchair,
  barcode,
  box,
  cable,
  cashregister,
  cd,
  chair,
  citybench,
  clock,
  computer,
  desk,
  desklamp,
  dockingStation,
  dvd,
  fan,
  fileCabinet,
  headphones,
  headset,
  hub,
  imac,
  ipad,
  iphone,
  keyboard,
  laptop,
  microphone,
  monitor,
  motherboard,
  mouse,
  nas,
  networkcard,
  other,
  pedestal,
  print,
  processor,
  router,
  scanner,
  server,
  sofa,
  speaker,
  switch: networkSwitch,
  trophy,
  tv,
  webcam,
  wheelchair,
  workstation,

  inventorize,
  disconnect,
  pickup,
  dropoff,
  reconnect,
  complete,

  'check-box-outline-blank': box, // TODO remove
  'desktop-windows': computer,
};



// WEBPACK FOOTER //
// ./src/utils/icons.js